import React from 'react';
import { IonImg } from '@ionic/react';

interface TrendHeaderProps {
  title: string;
  iconName?: string;
  rotateDisabled?: boolean;
  showRow?: boolean;
  showIcon?: boolean;
}

const SectionHeader: React.FC<TrendHeaderProps> = ({
  title,
  rotateDisabled = false,
  showRow = false,
  showIcon = true,
  iconName,
}) => {
  const svgIcon = iconName && `assets/icon/${iconName}.svg`;
  return (
    <div className="graph-header-row">
      <div className="grap-item">
        <div className="grap-row">
          {showIcon && svgIcon  && (
            <div className="graph-header-icon">
              <IonImg src={svgIcon} className="icon-rotate" />
            </div>
          )}

          <div className="label graph-header-label">{title}</div>
        </div>
        {/* {!rotateDisabled && (
          <div className="graph-rotate">
            <IonImg src="assets/icon/rotate.png" className="icon-rotate" />
            Rotate
          </div>
        )} */}
      </div>

      {showRow && <hr />}
    </div>
  );
};

export default SectionHeader;
